import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { StatusKYCSession } from "../../domain/user/Models/StatusKYCSession"

interface KycStatusState {
  kycStatus?: StatusKYCSession
  isLoading: boolean
  error?: string
}

interface KycStatusActions {
  getOrFetch: () => Promise<StatusKYCSession | undefined>
  updateKycStatus: () => Promise<StatusKYCSession | undefined>
  setKycStatus: (kycStatus: StatusKYCSession) => void
  reset: () => void
}

type KycStatusStore = KycStatusState & KycStatusActions

export const useKycStatusStore = create<KycStatusStore>()(
  devtools(
    (set, get) => ({
      kycStatus: undefined,
      isLoading: false,
      error: undefined,

      getOrFetch: async () => {
        const state = get()
        if (state.kycStatus) return state.kycStatus
        return state.updateKycStatus()
      },

      updateKycStatus: async () => {
        const state = get()
        if (state.isLoading) return undefined

        set({ isLoading: true, error: undefined })

        try {
          const { statusKYCSession } = await window.domain.GetStatusKYCSessionUserUseCase.execute()
          set({ kycStatus: statusKYCSession, isLoading: false })
          return statusKYCSession
        } catch (error) {
          set({ error: (error as Error).message, isLoading: false })
          throw error
        }
      },

      setKycStatus: (kycStatus: StatusKYCSession) => {
        set({ kycStatus })
      },

      reset: () => {
        set({ kycStatus: undefined, isLoading: false, error: undefined })
      },
    }),
    { name: "KycStatusStore" },
  ),
)
